import { API } from 'aws-amplify';
import { resolve } from '../../middleware/simple-promise';
import * as types from './types';


export const getMe = () => ({
  type: types.ME,
  payload: {
   promise: API.get('api', 'user/me')
  }
});

export const updateUser = (data) => ({
  type: types.UPDATE_USER,
  payload: {
    promise: API.put('api', 'user/me', { body: data })
  }
});

export const setUser = (user) => ({
  type: resolve(types.UPDATE_USER),
  payload: user
});

export const getStores = () => ({
  type: types.STORES,
  payload: {
    promise: API.get('api', 'user/stores')
  }
});

export const setStore = (store) => ({
  type: resolve(types.STORES),
  payload: [store]
});

export const selectStore = (id) => ({
  type: types.SELECT_STORE,
  payload: id
});

export const disconnectStore = (id) => ({
  type: types.DISCONNECT_STORE,
  payload: {
    promise: API.del('api', `stores/${id}`),
    id
  }
});

export const logout = () => (dispatch) => {
  dispatch({
    type: types.LOGOUT
  });
};

export const updatePref = (data) => {
  return {
    type: types.UPDATE_PREFERENCES,
    payload: {
      promise: API.put('api', 'user/me/preferences', { body: data }),
      data
    }
  }
};
